import { Divider, VStack } from "@gluestack-ui/themed";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { DetailsCreditProposalController } from "./controller";
import { ProposalAccordion } from "@repo/core/components/layout/ProposalAccordion";
import {
  GenderEnum,
  ProposalCardStatusEnum,
  RelationshipEnum
} from "@repo/core/enums/proposals";
import {
  dueDatesOptions,
  SectionEnum,
  viewSections
} from "@repo/core/screens/ProposalEffectiveFlows/Credit/DetailsCreditProposal/consts";
import { MustShow } from "@repo/core/components/core/MustShow";

const DetailsCreditProposal = () => {
  const { isMobile, handleGoBack, handleClose, isLoading, proposalType } =
    DetailsCreditProposalController();

  if (isLoading) {
    //TODO: Implement loading
    return null;
  }

  return (
    <>
      <Scaffolds.Root
        title={"Dados da proposta"}
        minHeight={isMobile ? "auto" : "auto"}
        onBackPress={handleGoBack}
        rightIcon="times"
        bg="$backgroundLight0"
        rightIconSize={20}
        rightWebLabel="Fechar"
        onPressRightIcon={handleClose}
      >
        <Scaffolds.Form minHeight="$100vh">
          <VStack flex={1} gap="$6" px="$4">
            <VStack my="$3" />
            <MustShow
              isVisible={viewSections[proposalType]?.includes(
                SectionEnum.PROPOSALS
              )}
            >
              <ProposalAccordion.IdentifyProposal
                title="Identificação da Proposta"
                value="proposalValue"
                isOpen={false}
                number="9999999"
                date="01/01/2023"
                status={ProposalCardStatusEnum.EFFECTIVE}
                typist="João da Silva"
                analyst="Maria da Silva"
                score="4,0"
                proposalType={proposalType}
                servicePoint="PA - PONTO DE ATENDIMENTO"
              />
              <Divider />
            </MustShow>
            <MustShow
              isVisible={viewSections[proposalType]?.includes(
                SectionEnum.IDENTIFICATION
              )}
            >
              <ProposalAccordion.Security
                title="Identificação do Cliente"
                value="clientIdentity"
                isOpen={false}
                cpf={"123.456.789-00"}
                proposalType={proposalType}
                name={"José da Silva"}
                phone={"(11) 99999-9999"}
              />
              <Divider />
            </MustShow>
            <MustShow
              isVisible={viewSections[proposalType]?.includes(
                SectionEnum.PERSONAL_DATA
              )}
            >
              <ProposalAccordion.Personal
                title="Dados Pessoais"
                value="personalData"
                proposalType={proposalType}
                isOpen={false}
                isShowEditButton={false}
                birthday="01/01/1980"
                gender={GenderEnum.MALE}
                martialStatus="S"
                mothersName="Maria da Silva"
              />
              <Divider />
            </MustShow>
            <MustShow
              isVisible={viewSections[proposalType]?.includes(
                SectionEnum.ADDRESS
              )}
            >
              <ProposalAccordion.Address
                title="Endereço Residencial"
                value="addressData"
                isOpen={false}
                isShowEditButton={false}
                addressLine1="Rua 1"
                number="123"
                proposalType={proposalType}
                addressLine2="Casa 1"
                neighborhood="Bairro 1"
                city="Cidade 1"
                state="Estado 1"
                zipCode="12345-678"
              />
              <Divider />
            </MustShow>
            <MustShow
              isVisible={viewSections[proposalType]?.includes(
                SectionEnum.PROFESSIONAL_DATA
              )}
            >
              <ProposalAccordion.Professional
                title="Atividade Profissional"
                value="professionalData"
                isOpen={false}
                isShowEditButton={false}
                proposalType={proposalType}
                admissionDate="01/01/1999"
                professionalCategory="Trabalhador Assalariado"
                profession="Programador"
                income="1000"
              />
              <Divider />
            </MustShow>
            <MustShow
              isVisible={viewSections[proposalType]?.includes(
                SectionEnum.REFERENCES
              )}
            >
              <ProposalAccordion.Reference
                title="Referência"
                value="professionalData"
                isOpen={false}
                proposalType={proposalType}
                isShowEditButton={false}
                isShowInput
                fullName="Maria da Silva"
                relationship={RelationshipEnum.DAD_MOTHER}
                phone="(11) 99999-9999"
              />
              <Divider />
            </MustShow>
            <MustShow
              isVisible={viewSections[proposalType]?.includes(
                SectionEnum.PARAMETERS
              )}
            >
              <ProposalAccordion.Parameters
                title="Parâmetros"
                value="proposalValue"
                productCardNumber="1234"
                productDescription="Fidelidade e crédito"
                productName="[Produto 1]"
                proposalName="Sem adessão"
                proposalValue="20,99"
                proposalType={proposalType}
                selectedInputType="15"
                dueDatesOptions={dueDatesOptions}
                isOpen={false}
              />
            </MustShow>
            <VStack h="$4" />
          </VStack>
        </Scaffolds.Form>
      </Scaffolds.Root>
    </>
  );
};

export default DetailsCreditProposal;
